import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { commissionLevel } from '~constants';
import { Empty } from 'antd';
import CommissionFormModal from '~components/commission/commission-form-modal';
import CommissionList from '~components/commission/commission-list';
import CreateCommission from '~components/commission/create-commission';
import { landlordStatus } from '~constants/landlord';

const Commission = ({ landlord, getLandlord }) => {
  const { commissionTiers, status } = landlord;

  const { t } = useTranslation();

  const [activeModal, setActiveModal] = useState(false);
  const [modalType, setModalType] = useState('addNew');
  const [correlationId, setCorrelationId] = useState(null);
  const [commissionCategory, setCommissionCategory] = useState(null);
  const [triggerPoint, setTriggerPoint] = useState('CREATED');

  const handleChangeCommissionCategory = item => {
    setCommissionCategory(item);
  };

  const handleCreateCommission = () => {
    setActiveModal(true);
    setTriggerPoint('CREATED');
  };

  const handleOpenModal = (type, commissionTier) => {
    setActiveModal(true);
    setModalType(type);
    setTriggerPoint(commissionTier?.triggerPoint || 'CREATED');
    setCorrelationId(commissionTier?.id);
    setCommissionCategory(
      (type === 'addNew' || type === 'copy') && commissionTier ? commissionTier.category : null,
    );
  };

  const handleCloseModal = () => {
    setActiveModal(false);
  };

  return (
    <>
      <p className="landlord-commission-title">{t('cms.property_card.action.btn.comission')}</p>
      <If condition={status === landlordStatus.VERIFIED}>
        <div className="landlord-commission">
          <If condition={commissionTiers && commissionTiers.length === 0}>
            <div className="landlord-commission__create">
              <div className="landlord-commission__create-main">
                <h3 className="landlord-commission__create--title">
                  {t('cms.landlord.commission.create.title')}
                </h3>

                <CreateCommission
                  t={t}
                  commissionLevel={commissionLevel.LANDLORD}
                  commissionCategory={commissionCategory}
                  changeCommissionCategory={handleChangeCommissionCategory}
                  createCommission={handleCreateCommission}
                />
              </div>
            </div>
          </If>

          <If condition={commissionTiers && commissionTiers.length > 0}>
            <CommissionList
              t={t}
              commissionLevel={commissionLevel.LANDLORD}
              commissionTier={commissionTiers}
              showOperations={true}
              openModal={handleOpenModal}
              afterDeleteCommission={getLandlord}
            />
          </If>

          <If condition={activeModal}>
            <CommissionFormModal
              t={t}
              activeModal
              triggerPoint={triggerPoint}
              commissionLevel={commissionLevel.LANDLORD}
              landlord={landlord}
              correlationId={correlationId}
              commissionTiers={commissionTiers}
              modalType={modalType}
              commissionCategory={commissionCategory}
              openModal={handleOpenModal}
              onClose={handleCloseModal}
              getLandlord={getLandlord}
              changeCommissionCategory={handleChangeCommissionCategory}
            />
          </If>
        </div>
      </If>
      <If condition={status !== landlordStatus.VERIFIED}>
        <div className="landlord-commission__not-verify-page">
          <Empty description={t('cms.commision.details.not_verify_hint')}></Empty>
        </div>
      </If>
    </>
  );
};

export default Commission;
